import { TYPES } from "../constants";
import ItemCard from "./ItemCard";

const ItemsGrid = ({
  activeType,
  filteredItems,
  loadingItems,
  onToggleActive,
  onDelete,
  onEdit,
}) => {
  return (
    <div className="lg:col-span-3 rounded-2xl border border-[#a6a6a6]/30 bg-white p-4 sm:p-5 shadow-sm w-full min-w-0">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h3 className="text-base sm:text-lg font-semibold text-[#000000]">
          Lista: {TYPES.find((x) => x.key === activeType)?.label}
        </h3>
        <span className="text-sm text-[#a6a6a6]">
          {loadingItems ? "..." : `${filteredItems.length} produkt(e)`}
        </span>
      </div>

      <div className="mt-4">
        {loadingItems ? (
          <div className="text-sm text-[#a6a6a6] py-4">Duke ngarkuar...</div>
        ) : filteredItems.length === 0 ? (
          <div className="rounded-xl border border-[#a6a6a6]/30 bg-[#e0d8c3]/10 p-4 text-sm text-[#a6a6a6]">
            S’ka asnjë produkt për këtë kategori ende.
          </div>
        ) : (
          <div className="grid gap-3 sm:gap-4 grid-cols-1 sm:grid-cols-2">
            {filteredItems.map((it) => (
              <ItemCard
                key={it.id}
                item={it}
                onToggleActive={onToggleActive}
                onDelete={onDelete}
                onEdit={onEdit}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ItemsGrid;
